import { QRCodeDotStyle } from 'types'
import { usePreference } from 'utils'

/** Record of items with utc number when it was dismissed */
export type DismissDateByIem = Record<'subscriptionUpsell', number>

export const useDismissDateByItem = () =>
  usePreference<DismissDateByIem | null>('dismiss-date-by-item', null, 1)

export interface QrCodePreferences {
  color: string
  dotStyle: QRCodeDotStyle
}

export const useQrCodePreferences = () =>
  usePreference<QrCodePreferences>(
    'qr-code-preferences',
    { color: 'black', dotStyle: 'rounded' },
    1
  )
